import { SITE_CONFIG } from "@/config/constants";
import { LegalDocument } from "@/app/components/legal/LegalDocument";
import { termsOfServiceContent as c } from "@/app/content/legalContent";

interface TermsOfServiceProps {
  mode?: "modal" | "page";
  onClose?: () => void;
}

export function TermsOfService({ mode = "page", onClose }: TermsOfServiceProps) {
  return (
    <LegalDocument title={c.title} closeLabel={c.closeLabel} mode={mode} onClose={onClose}>
      <p className="text-lg text-slate-600 mb-8">
        <strong>Data ostatniej aktualizacji:</strong> {c.lastUpdated}
      </p>

      {c.sections.map((section) => (
        <section key={section.heading} className="mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-4">{section.heading}</h2>

          {section.paragraphs?.map((p, i) => {
            const isEmailLine = p.includes(SITE_CONFIG.email);

            if (isEmailLine) {
              const [before, after] = p.split(SITE_CONFIG.email);
              return (
                <p key={i} className="text-slate-700 leading-relaxed mb-4">
                  {before}
                  <a href={`mailto:${SITE_CONFIG.email}`} className="text-[#004f4f] underline">
                    {SITE_CONFIG.email}
                  </a>
                  {after}
                </p>
              );
            }

            return (
              <p key={i} className="text-slate-700 leading-relaxed mb-4">
                {p}
              </p>
            );
          })}

          {section.items && (
            <ul className="list-disc pl-6 mb-4 text-slate-700 space-y-2">
              {section.items.map((item, i) => {
                const isEmailItem = item.includes(SITE_CONFIG.email);
                if (isEmailItem) {
                  const [before, after] = item.split(SITE_CONFIG.email);
                  return (
                    <li key={i}>
                      {before}
                      <a
                        href={`mailto:${SITE_CONFIG.email}`}
                        className="text-[#004f4f] underline"
                      >
                        {SITE_CONFIG.email}
                      </a>
                      {after}
                    </li>
                  );
                }
                return <li key={i}>{item}</li>;
              })}
            </ul>
          )}
        </section>
      ))}
    </LegalDocument>
  );
}
